<form [formGroup]="tad_business_details_form">
    <div class="row">
        <div class="col col-md-6">
            <div class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_company_name')">
                <label for="tad_company_name">Company name</label>
                <input type="text" class="form-control" [ngClass]="setDynamicClasses('tad_company_name')" formControlName="tad_company_name" name="tad_company_name" id="tad_company_name" aria-describedby="tad_company_name">
                <together-auction-dip-validate-fields [displayError]="tad_business_details_form.get('tad_company_name').touched && tad_business_details_form.get('tad_company_name').errors?.required" errorMsg="We need the company name."></together-auction-dip-validate-fields>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col col-md-6">
            <div class="form-group">
                <label>Company address</label>
                <app-address [incomingAddress]="companyAddress" [addressLookUp]="tad_business_details_form.controls.addresslookup" (form_out)="_handleIncomingForm($event)" (outgoingAddress)="_handleIncomingAddress($event)">
                </app-address>
            </div>
        </div>
    </div>
</form>
